import { render, staticRenderFns } from "./booyah.vue?vue&type=template&id=74c20d85&"
import script from "./booyah.vue?vue&type=script&lang=js&"
export * from "./booyah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports